/* eslint-disable jsx-a11y/alt-text */
import React, { useDeferredValue, useEffect, useMemo, useRef, useState } from "react";

import { useSharedData } from "bossjob-remote/dist/hooks";
import { Collapse, Drawer, Input, Modal } from "antd";
import { DownIcon, LeftIcon, SearchIcon } from "./assets";
import classNames from "classnames";
import { getCountryId } from "helpers/country";
import styles from "./index.module.scss";
import { uniqBy } from "lodash-es";
import empty3 from "../../../emptyImg/empty3.png";

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const PreferenceLocationMobile = (props: {
  value?: {
    id: any;
    value: any;
  };
  lang?: Record<string, any>;
  onChange: (selectItem?: any) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  text: {
    title: string;
    expandText: string;
    collapseText: string;
    inputPlaceholder: string;
  };
  showOtherCountry?: boolean;
  onOtherCountryClick?: () => void;
  preference: any;
}) => {
  //
  const {
    value: outerValue,
    onChange,
    open,
    onOpenChange,
    text,
    showOtherCountry,
    onOtherCountryClick,
    preference
  } = props;
  const config = useSharedData("CONFIG");
  const dic = useSharedData("DICTIONARY");
  const AllText = dic?.companyDetail?.overview?.All;
  const configCountryLists = (config && config?.country_lists) ?? [];
  const countryId = getCountryId();
  const showFirstLevel = /^(?:193|229|38|29|154|227|203|190)$/.test(String(countryId));
  const findLists = configCountryLists?.find((e) => e.id === countryId);
  const [countryLists, setCountryLists] = useState<any[]>([]);
  const [activeKeys, setActiveKeys] = useState([]);
  const [value, setValue] = useState([]);
  const otherCountries = dic?.profile?.baseProfile?.otherCountries;
  const [inputValue, setInputValue] = useState("");
  const deferredValue = useDeferredValue(inputValue);
  const contentRef = useRef<HTMLDivElement>(null);
  console.log({ countryLists });

  useEffect(() => {
    if (findLists?.id) {
      const regionLists = findLists.region_lists.map((e) => ({
        ...e,
        type: "region"
      }));
      regionLists?.unshift({
        id: findLists.id,
        key: findLists.key,
        value: showFirstLevel ? AllText + " " + findLists.value : findLists.value,
        type: "country"
      });

      const uniArr = uniqBy(regionLists, "id");
      const list = [];

      uniArr.map((e) => {
        const item = {
          id: e.id,
          key: e.key,
          label: e.value || e.display_name,
          value: e.id,
          type: e.type || "region",
          children: []
        };

        if (e.location_lists?.length > 0 && !showFirstLevel) {
          if (e.location_lists[0]?.key === "overseas") {
            return;
          }

          item.children.push({
            id: e.id,
            value: e.id,
            key: e.key,
            type: "region",
            label: `${AllText} ${item.label}`
          });
          e.location_lists.map((k) => {
            item.children.push({
              id: k.id,
              value: k.id,
              key: k.key,
              type: "location",
              label: k.value
            });
          });
        } else {
          item.label = e.value || e.display_name;
        }

        list.push(item);
      });
      if (showOtherCountry) {
        let otherCountryItem = {
          id: -1,
          key: "other_countries",
          value: "other_countries",
          label: null,
          type: ""
        };
        let child = Object.assign({}, otherCountryItem, {
          label: (
            <span
              className='reset-label'
              onClick={(e) => {
                e.stopPropagation();
                setTimeout(() => {
                  onOtherCountryClick();
                }, 300);
              }}
            >
              {otherCountries}
            </span>
          )
        });
        if (!showFirstLevel) {
          list.push(
            Object.assign({}, otherCountryItem, {
              label: <span>{otherCountries}</span>,
              children: [child]
            })
          );
        } else {
          list.push(child);
        }
      }
      if (!showFirstLevel) {
        list[0].children = [
          {
            id: findLists.id,
            key: findLists.key,
            value: findLists.id,
            label: `${AllText + " " + findLists.value}`,
            type: "country"
          }
        ];
      }
      setCountryLists(list);
    }
  }, [findLists, AllText, showFirstLevel]);

  useEffect(() => {
    if (preference?.id && countryLists?.length > 0) {
      const { pref_country_id, pref_region_id, location_id } = preference || {};
      let arr = [];
      if (pref_country_id) {
        arr = showFirstLevel ? [pref_country_id] : [pref_country_id, pref_country_id];
      } else if (pref_region_id) {
        arr = showFirstLevel ? [pref_region_id] : [pref_region_id, pref_region_id];
      } else if (location_id) {
        for (const country of countryLists) {
          const location = country.children.find((k) => k.id === location_id);
          if (location) {
            arr = [country.id, location_id];
            break;
          }
        }
      }

      setValue(arr);

      // TODO: need refactor @taylor

      if (countryLists.length) {
        countryLists.forEach((country) => {
          const _id = pref_country_id || pref_region_id;
          if ((pref_country_id || pref_region_id) && country.id == _id) {
            console.log({ countryLists });
            onChange(country?.children?.[0] || country);
          } else {
            const children = country.children;
            if (location_id && children) {
              const country = children.find((e) => e.id === location_id);
              if (country) {
                onChange(country);
              }
            }
          }
        });
      }
    }
  }, [preference, countryLists, showFirstLevel]);

  const filteredOpt = useMemo(() => {
    let convertedValue = countryLists;

    if (deferredValue) {
      convertedValue = (convertedValue || [])
        .map((subListItem) => {
          let children = (subListItem?.children || [])
            .map((jobTitle) => {
              let include = `${jobTitle.label}`
                .toLocaleLowerCase()
                .includes(deferredValue.toLocaleLowerCase());
              if (include) {
                return {
                  ...jobTitle,
                  originalLabel: jobTitle.label,
                  label: `${jobTitle.label}`.replaceAll(
                    new RegExp(escapeRegExp(deferredValue), "gi"),
                    `<span>$&</span>`
                  )
                };
              }
              return null;
            })
            .filter(Boolean);
          return children?.length ? { ...subListItem, children } : null;
        })
        .filter(Boolean);
      console.log({ convertedValue });
    }
    return convertedValue;
  }, [countryLists, deferredValue]);

  useEffect(() => {
    document.getElementById("checkedFunction")?.scrollIntoView?.({ block: "center" });
  }, [open]);

  let showFilterOpt = Boolean(filteredOpt.length && inputValue);

  const currentKeys = showFilterOpt
    ? filteredOpt.map((v, i) => {
        return `${v.id}`;
      })
    : activeKeys;

  let renderItems = showFilterOpt ? filteredOpt : countryLists;
  const items = renderItems.map((v, i) => {
    return {
      key: v.id,
      value: v.id,
      label: (
        <div className={styles.mainHeader}>
          {v.label}
          <span
            className={classNames(styles.iconWrapper, currentKeys.includes(`${i}`) && styles.open)}
          >
            <DownIcon />
          </span>
        </div>
      ),
      children: (
        <div className={styles.jobTitleWrapper}>
          {(v?.children || []).map((item) => {
            const hasChecked = value?.[value?.length - 1] == item.value;
            return (
              <div
                key={item.id}
                onClick={(e) => {
                  onChange({
                    ...item,
                    value: item.value,
                    label: item.originalLabel || item.label
                  });
                  setValue([item.value]);

                  onOpenChange(false);
                }}
                id={hasChecked ? "checkedFunction" : ""}
                className={classNames(styles.jobTitleItem, hasChecked && styles.checked)}
              >
                <>
                  {typeof item.label == "string" ? (
                    <div dangerouslySetInnerHTML={{ __html: item.label }} />
                  ) : (
                    item.label
                  )}
                </>
              </div>
            );
          })}
          <div style={{ height: 12 }}></div>
        </div>
      ),
      showArrow: false
    };
  });

  const toggle = () => {
    onOpenChange(!open);
  };

  let doesAllOpened = showFilterOpt
    ? false
    : currentKeys.length === Object.keys(countryLists).length;

  return (
    <>
      <Drawer
        zIndex={3000}
        open={open}
        onClose={toggle}
        styles={{ header: { display: "none" } }}
        height={"100%"}
        placement='bottom'
        afterOpenChange={(open) => {
          if (!open) {
            setInputValue("");
          }
        }}
        className={styles.drawerRoot}
      >
        <div className={styles.drawerContent}>
          <div className={styles.headerRoot}>
            <span className={styles.leftBackBtn} onClick={toggle}>
              <LeftIcon />
            </span>
            <div className={styles.title}>
              {text.title}
              {/* Job Title */}
            </div>
            {!inputValue && (
              <span
                className={styles.headerBtn}
                onClick={(e) => {
                  if (showFilterOpt) {
                    return;
                  }
                  setActiveKeys(doesAllOpened ? [] : countryLists.map((e) => e.id));
                }}
              >
                {doesAllOpened ? text.collapseText : text.expandText}
              </span>
            )}
          </div>

          <div className={styles.inputWrapper}>
            <Input
              prefix={<SearchIcon />}
              placeholder={text.inputPlaceholder}
              value={inputValue}
              onChange={(e) => {
                let value = e.target.value;
                setInputValue(value);
              }}
            />
          </div>

          {inputValue && !filteredOpt.length ? (
            <div
              className={styles.addRow}
              // onClick={(e) => {
              //   if ((e.target as HTMLSpanElement).className.includes("highlight")) {
              //     onOpenChange(false);
              //     onChange({
              //       label: inputValue,
              //       value: 881 // 881 is the if of other jobs
              //     });
              //   }
              // }}
              // dangerouslySetInnerHTML={{
              //   __html: formatTemplateString(
              //     emptyString,
              //     `<span class="highlight">${dic?.profile?.add || "Add"}</span>`
              //   )
              // }}
            >
              <img src={empty3.src} />
              <p>Try another keyword, or double-check you're searching in the right country.</p>
            </div>
          ) : (
            <div ref={contentRef} style={{ position: "relative", flex: 1, overflow: "scroll" }}>
              <Collapse
                activeKey={currentKeys}
                onChange={
                  showFilterOpt
                    ? null
                    : (newValue) => {
                        let lastOne = newValue[newValue.length - 1];

                        if (lastOne && lastOne === `${`${renderItems.length - 1}`}`) {
                          setTimeout(() => {
                            contentRef.current?.scrollTo?.({
                              top: contentRef.current.scrollTop + 200
                            });
                          }, 200);
                        }
                        setActiveKeys(newValue);
                      }
                }
                ghost
                items={items}
                className={styles.jobFunctionCollapse}
              />
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};
